module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#youtube",
      toString: function () {
        return this.url;
      }
    }